import React from 'react';
import { InferableComponentEnhancerWithProps } from 'react-redux';
import { getStore } from 'store/store';
import { Schema } from 'yup';

import * as FormsTypes from 'reactApp/components/Forms/Forms.types';
import { Forms } from 'reactComponents/Forms';

const _defaultFormikParamsMapper = (_formikParams) => ({ _formikParams });

type InjectedProps<Values> = {
    _formikParams: Required<FormsTypes.ExtendedFormikProps<Values>>;
    setSubmitHandler: (submitHandler: Function) => void;
    setValidation: (validateFunc: Function) => void;
};

type NeedProps = {};

// TODO: type global state
export type FormikParamsMapper<OwnProps, Values> = (
    props: OwnProps,
    state: any,
) => {
    validationSchema?: Schema<any>;
    initialValues: Partial<Values>;
    theme?: string;
    onSubmit?: any;
    validate?: any;
};

type Connector = <OwnProps, Values>(
    mapPropsToFormikWrapperParams: FormikParamsMapper<OwnProps, Values>,
) => InferableComponentEnhancerWithProps<
    InjectedProps<Values>,
    NeedProps & OwnProps
>;

export const connectFormikProps: Connector = (
    mapPropsToFormikWrapperParams,
    // @ts-ignore
) => (WrappedComponent) => {
    return class FormikPropsConnector extends React.PureComponent {
        _paramsProvider: ParamsProvider;

        constructor(props) {
            super(props);

            this._paramsProvider = new ParamsProvider();
        }

        render() {
            const wrapperParams = mapPropsToFormikWrapperParams(
                this.props as any,
                getStore().getState(),
            );

            const wrappedComponentProps: any = {
                ...this.props,
            };

            if (!wrapperParams.onSubmit) {
                wrapperParams.onSubmit = this._paramsProvider.onSubmit;

                wrappedComponentProps.setSubmitHandler = this._paramsProvider.setSubmitHandler;
            }

            if (!wrapperParams.validate && !wrapperParams.validationSchema) {
                wrapperParams.validate = this._paramsProvider.validate;

                wrappedComponentProps.setValidation = this._paramsProvider.setValidation;
            }

            return (
                <Forms.FormWrapper
                    {...wrapperParams}
                    render={(renderProps) => {
                        return (
                            <WrappedComponent
                                {...{
                                    ...wrappedComponentProps,
                                    ..._defaultFormikParamsMapper(renderProps),
                                }}
                            />
                        );
                    }}
                />
            );
        }
    };
};

class ParamsProvider {
    // @ts-ignore
    onSubmit = (...args) => this._handleSubmit(...args);

    setSubmitHandler = (func) => {
        this._handleSubmit = func;
    };

    // @ts-ignore
    validate = (...args) => this._validate(...args);

    setValidation = (func) => {
        this._validate = func;
    };

    _handleSubmit() {}

    _validate() {
        return {};
    }
}
